<template>
  <div class="toast-message flex-between-center" :class="toastColorClass">
    <div class="flex-between-center">
      <!-- Icon -->
      <div>
        <div class="icon-circle mx-3">
          <i class="fas" :class="toastIconClass"></i>
        </div>
      </div>
      
      <!-- Title + subtitle -->
      <div>
        <h6 class="font-weight-bold mb-0">{{ toast.title }}</h6>
        <p class="text-muted toast-message-text mt-1 mb-0">{{ toast.message }}</p>
      </div>
    </div>
    
    <!-- Close button -->
    <button type="button" class="close ml-2 p-1" aria-label="Close" @click.stop="$emit('remove', toast.id)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ToastMessage",

  props: {
    toast: {
      type: Object
    }
  },

  computed: {
    toastColorClass() {
      const { type } = this.toast;

      if (["success", "warning", "danger"].includes(type)) {
        return `toast-message-${type}`;
      }
    },

    toastIconClass() {
      switch (this.toast.type) {
        case "success":
          return "fa-check";
        case "warning":
          return "fa-exclamation";
        case "danger":
          return "fa-times";
        default:
          return "fa-info";
      }
    }
  }
}
</script>

<style scoped>
.toast-message {
  width: 400px;
  position: relative;
  background: white;
  padding: 0.8em 1.6em;
  padding-left: 1em;
  border-radius: 0.5em;
  margin-top: 0.6em;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.15);
}

.toast-message::before {
  content: "";
  width: 4px;
  height: calc(100% - 1.2em);
  display: block;
  position: absolute;
  left: 0.6em;
  border-radius: 2px;
  background-color: var(--primary);
}

.toast-message.toast-message-success::before {
  background-color: var(--success);
}
.toast-message.toast-message-warning::before {
  background-color: var(--warning);
}
.toast-message.toast-message-danger::before {
  background-color: var(--danger);
}


.toast-message .icon-circle {
  border-radius: 50%;
  background-color: var(--primary);
  color: white;
  text-align: center;
  width: 2em;
  height: 2em;
  line-height: 2em;
  font-size: 0.8em;
}

.toast-message.toast-message-success .icon-circle {
  background-color: var(--success);
}
.toast-message.toast-message-warning .icon-circle {
  background-color: var(--warning);
}
.toast-message.toast-message-danger .icon-circle {
  background-color: var(--danger);
}

.toast-message .close {
  float: none;
  font-size: 1.2rem;
}

.toast-message-text {
  line-height: 1.2em;
}
</style>